/**
 * Global 3 transition sidebar menu
 * 
 * Temporary dynamic sidebar menu until full Global 4 rollout 
 */

import $ from 'jquery';
import { getPageId, getActiveMenuItem } from 'components/navigation/active-menu-item.js';

const sidebarMenuContainer = document.querySelector('.transition-sidebar');
const pageId = getPageId();

if (sidebarMenuContainer) {
 
  // Navigate to active menu item if applicable
  if (pageId) {
    const activeMenuItem = getActiveMenuItem(sidebarMenuContainer, '[data-drilldown]');
    if (activeMenuItem) {
      const [activeDrilldown, activeMenu, activeLink] = activeMenuItem;
      if (activeLink && activeMenu && activeDrilldown) {
        // Set active class
        activeLink.classList.add('is-active');

        // Open relevant drilldown submenu on page load after Foundation loads
        $(activeDrilldown).on('init.zf.drilldown', () => {
          // Open the submenu containing the active link
          $(activeDrilldown).foundation('_showMenu', $(activeMenu), false);
          
          // If active link is a submenu parent (folder index) open its submenu
          const activeLinkLi = activeLink.closest('li');
          if (activeLinkLi) {
            const childSubmenu = activeLinkLi.querySelector('ul.menu');
            if (childSubmenu) {
              $(activeDrilldown).foundation('_showMenu', $(childSubmenu), false);
            }
          }
        });
      }
    }
  }
}